import { Routes } from '@angular/router';
import { canActivateIfAuthenticated } from '@app/core/routing/can-activate-if-authenticated';
import { canActivateIfUnauthenticated } from '@app/core/routing/can-activate-if-unauthenticated';
import { canMatchWithSettledAuthState } from '@app/core/routing/can-match-with-settled-auth-state';

export const APP_ROUTES: Routes = [
    {
        path: 'auth',
        canActivate: [ canActivateIfUnauthenticated('/envelopes') ],
        loadChildren: async () => {
            const m = await import('src/app/features/authentication/authentication.routes');
            return m.AUTHENTICATION_ROUTES;
        },
    },
    {
        path: 'logout',
        canActivate: [ canActivateIfAuthenticated('/auth/login') ],
        loadComponent: async () => {
            const m = await import('src/app/features/authentication/logout/logout-page');
            return m.LogoutPage;
        },
    },
    {
        path: '',
        loadComponent: async () => {
            const module = await import('src/app/layouts/header/header-layout');
            return module.HeaderLayout;
        },
        children: [
            {
                path: 'account',
                canActivate: [ canActivateIfAuthenticated('/auth/login') ],
                loadComponent: async () => {
                    const m = await import('src/app/features/account/account');
                    return m.Account;
                },
            },
            {
                path: 'envelopes',
                canMatch: [ canMatchWithSettledAuthState ],
                loadChildren: async () => {
                    const m = await import('src/app/features/envelopes/envelopes.routes');
                    return m.ENVELOPE_ROUTES;
                },
            },
            {
                path: '**',
                redirectTo: 'envelopes',
            },
        ],
    },
    {
        path: '**',
        redirectTo: '/envelopes',
    },
];